module.exports = "/_next/static/images/impactPlusEmptyState-a5f0944d7f868a7ac7d2523b883c9e94.svg";